import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=6acbf90b&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"
import style0 from "./SideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=6acbf90b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acbf90b",
  null
  
)

component.options.__file = "SideBar.vue"
export default component.exports